/* eslint-disable max-len */
import { Fragment, useEffect, useState } from 'react';
import cookie from 'react-cookies';
import { isAndroid, isIOS, isMacOs, isWindows } from 'react-device-detect';
import { useAsync } from 'react-use';
import { useRouter } from 'next/router';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Avatar, Button, Col, Form, Grid, Image, Layout, Modal, Row, Space, Typography } from 'antd';
import { Footer } from 'antd/lib/layout/layout';
import Paragraph from 'antd/lib/typography/Paragraph';
import CryptoJS from 'crypto-js';
import Comment from 'src/components/Comment';
import { ButtonBorder, ButtonBorderKomunitas } from 'src/components/Forms/Button';
import IconCustom from 'src/components/Icon/Custom';
import ImageC from 'src/components/Image';
import SubmitFormButton from 'src/components/Inputs/SubmitForm';
import TextAreaInput from 'src/components/Inputs/TextArea';
// import messageC from 'src/components/Message';
import g from 'src/constants/urls';
import { decryptDLoginBE } from 'src/utils/func/encrypt';
import dayjs from 'src/utils/moment';
import ArticleDetail from '../Category/ArticleDetail';
import ArticleDownloadBanner from './ArticleDownload/index';
import GeneralArticleContainer from './GeneralArticle';
import SocialShareModal from './Share';
import classes from './index.module.less';
import { useMessageC } from '@/utils/useMessage';

// ============================================================================
// Pure helper functions (tidak bergantung pada state komponen, aman di luar)
// ============================================================================
const getRandomColor = (username: string) => {
  const colors = ['#87d068', '#34c759', '#8bc34a', '#45b3fa', '#9c27b0', '#2196f3', '#ff9800', '#03a9f4', '#70cbb2', '#F48A8A', '#ba6729', '#4eceff', '#a18cd1', '#fd6871', '#fbc2eb', '#ffda4d'];
  let hash = 0;
  for (let i = 0; i < username?.length; i++) {
    hash = username?.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
};
const getRandomInitials = (username: any) => {
  const names = username?.split(' ');
  const firstTwoNames = names?.slice(0, 2);
  const initials = firstTwoNames?.map((name: any) => name[0]).join('');
  return initials?.toUpperCase();
};

// ============================================================================
// CommentComponent - dipindah ke luar, terima semua dependency lewat props
// ============================================================================
interface CommentComponentProps {
  item: any;
  artikelUid: string;
  dtLogin: any;
  xs: boolean | undefined;
  newLikeComment: number;
  setNewLikeComment: (val: number) => void;
  showModal: (item: boolean) => void;
  messageC: (msg: string) => void;
}
const CommentComponent = ({
  item,
  artikelUid,
  dtLogin,
  xs,
  newLikeComment,
  setNewLikeComment,
  showModal,
  messageC
}: CommentComponentProps) => {
  const [isComment, setIsComment] = useState('');
  const randomColor = getRandomColor(item?.user_name);
  const initials = getRandomInitials(item?.user_name);
  const likeComment = async (uidComment: any) => {
    try {
      const response = await fetch(`${g.API_PWD}/article-like/${artikelUid}/${uidComment}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${dtLogin.token}`
        }
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const result = await response.json();
      if (result.meta.code === 204000) {
        setNewLikeComment(newLikeComment + 1);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'page_article_comment_like',
          uid: dtLogin.uid,
          email: dtLogin.email,
          name: dtLogin.name,
          uidComment: uidComment,
          uidArtikel: artikelUid
        });
        messageC(result.data.record.status === true ? 'Mama berhasil like komentar ini! Makasih like-nya Ma~' : 'Mama batal suka komentarnya');
      }
    } catch (error) {
      messageC('Gagal like');
    }
  };
  const [isClicked, setIsClicked] = useState(false);
  const showMore = (uid: any, comment: any) => {
    setIsClicked(isClicked === false ? true : false);
    if (isClicked === false) {
      setIsComment(comment.substring(0, 100));
    } else if (isClicked === true) {
      setIsComment(comment);
    }
    return comment;
  };
  useEffect(() => {
    console.log('TESTER', item);
  }, [isComment]);
  return <Comment actions={[<span key={item?.uid} className="d-flex align-items-center" style={{
    marginLeft: '0px'
  }}>
					{dtLogin?.uid ? <IconCustom iconName={item?.is_like === true ? 'heartColor' : 'heart'} onClick={() => likeComment(item?.uid)} id="detail-artikel-comment-like" /> : <IconCustom iconName="heart" id="detail-artikel-comment-like" onClick={() => showModal(true)} />}
					<Typography style={{
      color: '#9ca3aa'
    }}>{item?.total_like}</Typography>
				</span>]} author={<Typography>
					<span style={{
      color: 'black',
      fontSize: xs ? '16px' : '18px',
      fontWeight: '500'
    }}>
						{item?.user_name}
					</span>{' '}
					<span style={{
      margin: '10px'
    }}>
						<ImageC src="/images/default/titik.svg" width={7} height={7} />
					</span>{' '}
					<span style={{
      fontSize: '12px'
    }}>{item?.created_at_in_ago}</span>
				</Typography>} avatar={item?.user_avatar_url.length > 0 ? <Avatar src={item?.user_avatar_url} alt={item?.user_name} /> : <Avatar style={{
    backgroundColor: randomColor
  }} alt={item?.user_name}>
						{initials}
					</Avatar>} content={<p suppressHydrationWarning>
					{item?.comment.length < 60 ? item?.comment : isClicked === false ? item?.comment.substring(0, 60) : isClicked === true ? item?.comment : item?.comment}
					<a className="btn btn-primary" onClick={() => showMore(item?.uid, item?.comment)}>
						{item?.comment.length > 60 ? isClicked === false ? <span> tampilkan selengkapnya</span> : <span> lihat lebih sedikit</span> : ''}
					</a>
				</p>}>
			{item?.reply !== null && <div style={{
      marginLeft: 40
    }}>
					{item?.reply.is_admin === true ? <Comment actions={[<span key={item?.reply.uid} className="d-flex align-items-center" style={{
        marginLeft: '0px'
      }}>
									{dtLogin?.uid ? <IconCustom iconName={item?.reply.is_like === true ? 'heartColor' : 'heart'} onClick={() => likeComment(item?.reply.uid)} id="detail-artikel-comment-mima-like" /> : <IconCustom iconName="heart" id="detail-artikel-comment-mima-like" onClick={() => showModal(true)} />}
									<Typography style={{
          color: '#9ca3aa'
        }} onClick={() => showModal(true)}>
										{item?.reply.total_like}
									</Typography>
								</span>]} author={<Typography>
									<span style={{
          color: 'black',
          fontSize: xs ? '16px' : '18px',
          fontWeight: '500'
        }}>
										Admin MIMA
									</span>{' '}
									<span style={{
          margin: '10px'
        }}>
										<ImageC src="/images/default/titik.svg" width={7} height={7} />
									</span>{' '}
									<span style={{
          fontSize: '12px'
        }}>{item?.reply.created_at_in_ago}</span>
								</Typography>} avatar={<Avatar src={'/images/default/mima.svg'} alt="Admin MIMA"></Avatar>} content={<p>{item?.reply.comment}</p>}></Comment> : <Comment actions={[<span key={item?.reply.uid} className="d-flex align-items-center" style={{
        marginLeft: '0px'
      }}>
									{dtLogin?.uid ? <IconCustom iconName={item?.is_like === true ? 'heartColor' : 'heart'} onClick={() => likeComment(item?.reply.uid)} id="detail-artikel-comment-like" /> : <IconCustom iconName="heart" onClick={() => showModal(true)} id="detail-artikel-comment-like" />}
									<Typography style={{
          color: '#9ca3aa'
        }} onClick={() => showModal(true)}>
										{item?.reply.total_like}
									</Typography>
								</span>]} author={<Typography>
									<span style={{
          color: 'black',
          fontSize: xs ? '16px' : '18px',
          fontWeight: '500'
        }}>
										{item?.reply.user_name}
									</span>{' '}
									<span style={{
          margin: '10px'
        }}>
										<ImageC src="/images/default/titik.svg" width={7} height={7} />
									</span>{' '}
									<span style={{
          fontSize: '12px'
        }}>{item?.reply.created_at_in_ago}</span>
								</Typography>} avatar={item?.user_avatar_url.length > 0 ? <Avatar src={item?.user_avatar_url} alt={item?.user_name} /> : <Avatar style={{
        backgroundColor: randomColor
      }} alt={item?.user_name}>
										{initials}
									</Avatar>} content={<p>{item?.reply.comment}</p>}></Comment>}
				</div>}
		</Comment>;
};

// ============================================================================
// CommentComponentUserLogin - dipindah ke luar, terima dependency lewat props
// ============================================================================
interface CommentComponentUserLoginProps {
  dtLogin: any;
  artikelUid: string;
  cryptoData: string;
  messageC: (msg: string) => void;
  newArtikels: number;
  setNewArtikels: (val: number) => void;
}
const CommentComponentUserLogin = ({
  dtLogin,
  artikelUid,
  cryptoData,
  messageC,
  newArtikels,
  setNewArtikels
}: CommentComponentUserLoginProps) => {
  const randomColor = getRandomColor(!dtLogin.name ? 'Hallo Mama' : dtLogin.name);
  const initials = getRandomInitials(!dtLogin.name ? 'Hallo Mama' : dtLogin.name);
  const [form] = Form.useForm();
  const [processing, setProcessing] = useState(false);
  const onHandleFinishForm = async (values: any) => {
    try {
      const response = await fetch(`${g.API_PWD}/article-comment/${artikelUid}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${dtLogin.token}`,
          'X-api-platform': cryptoData
        },
        body: JSON.stringify({
          article_comment: values.comment
        })
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const result = await response.json();
      if (result.meta.code === 204000) {
        setNewArtikels(newArtikels + 1);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'page_article_comment_send',
          uid: dtLogin.uid,
          email: dtLogin.email,
          name: dtLogin.name,
          uidArtikel: artikelUid
        });
      }
      setProcessing(false);
      messageC('Komentar berhasil terkirim! Makasih Ma udah berbagi~');
    } catch (error) {
      messageC('Komentar mama Gagal terkirim nih! coba sebentar lagi ya ma.');
      setProcessing(false);
    }
  };
  return <div>
			<Row>
				<Col sm={24} md={24} xs={24} lg={24}>
					<Comment avatar={dtLogin?.profile_image_files !== null ? <Avatar src={dtLogin?.profile_image_files[0]?.path} alt={dtLogin.name} style={{
          marginTop: '10px'
        }} /> : <Avatar style={{
          backgroundColor: randomColor,
          marginTop: '10px'
        }} alt={dtLogin.name}>
									{initials}
								</Avatar>} content={<>
								<Form className={classes.wrapper} autoComplete="off" name="login-us-form" onFinish={onHandleFinishForm} form={form}>
									<Row>
										<Col sm={22} md={22} xs={19} lg={22}>
											<TextAreaInput name="comment" placeholder="Tambahkan komentar... " rules={[{
                  required: true,
                  message: 'Komentar tidak boleh kosong'
                }, {
                  validator: (_: any, value: any) => {
                    if (!value || value.trim() === '') {
                      return Promise.reject(new Error('Komentar tidak boleh kosong atau hanya spasi'));
                    }
                    if (value !== value.trim()) {
                      return Promise.reject(new Error('Komentar tidak boleh dimulai atau diakhiri dengan spasi'));
                    }
                    return Promise.resolve();
                  }
                }]} maxLength={2200} />
										</Col>
										<Col sm={2} md={2} xs={3} lg={2}>
											<SubmitFormButton label={<span>Kirim</span>} isProcessing={processing} className={classes.btnComment} />
										</Col>
									</Row>
								</Form>
							</>} />
				</Col>
			</Row>
		</div>;
};

// ============================================================================
// CommentComponentNonLogin - dipindah ke luar, terima dependency lewat props
// ============================================================================
interface CommentComponentNonLoginProps {
  setIsModalOpen: (item: boolean) => void;
}
const CommentComponentNonLogin = ({
  setIsModalOpen
}: CommentComponentNonLoginProps) => {
  const [form] = Form.useForm();
  const [processing] = useState(false);
  const showKomentars = (item: boolean) => {
    setIsModalOpen(item);
  };
  return <div>
			<Row>
				<Col sm={24} md={24} xs={24} lg={24}>
					<Comment content={<>
								<Form className={classes.wrapper} autoComplete="off" name="login-us-form" form={form}>
									<Row>
										<Col sm={22} md={22} xs={19} lg={22}>
											<TextAreaInput name="comment" placeholder="Tambahkan komentar..." maxLength={2200} onClick={() => showKomentars(true)} />
										</Col>
										<Col sm={2} md={2} xs={3} lg={2}>
											<SubmitFormButton label={<span>Kirim</span>} isProcessing={processing} className={classes.btnComment} />
										</Col>
									</Row>
								</Form>
							</>} />
				</Col>
			</Row>
		</div>;
};

// ============================================================================
// Main container
// ============================================================================
const ArticleDetailContainer = (props: any) => {
  const {
    xl,
    lg,
    xs
  } = Grid.useBreakpoint();
  const artikelUid = props.artikel.uid;
  const router = useRouter();
  const messageC = useMessageC();
  const [dtLogin, setDataLogin] = useState<any>({});
  useEffect(() => {
    const fetchData = async () => {
      if (cookie.load('d_login')) {
        const userData = decryptDLoginBE(cookie.load('d_login'));
        setDataLogin(userData);
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'articlePage',
      article_title: props.artikel.title,
      article_type: props.artikel.type,
      article_category: props.artikel?.categories?.slug
    });
    window.scrollBy({
      top: 5,
      left: 0,
      behavior: 'smooth'
    });
  }, []);
  const url = `${process.env.NEXT_PUBLIC_WEB_URL}${router.asPath?.split('?')[0]}`;
  const copyLink = () => {
    const cb = navigator.clipboard;
    cb.writeText(`${window.location.origin}${router.asPath?.split('?')[0]}`).then(() => {
      messageC('Copied');
    });
  };
  const sosmed = {
    social_media: [{
      icon: '/images/default/logoFbColor.svg',
      name: 'Facebook',
      deeplink: `https://www.facebook.com/sharer/sharer.php?u=${url}`
    }, {
      icon: '/images/default/logoXColor.svg',
      name: 'Twitter',
      deeplink: `https://twitter.com/intent/tweet?url=${url}`
    }, {
      icon: '/images/default/logoWaColor.svg',
      name: 'WA',
      deeplink: `https://api.whatsapp.com/send?text=${url}`
    }, {
      icon: '/images/default/logoCopy.svg',
      name: 'copylink',
      deeplink: ''
    }]
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = (item: boolean) => {
    setIsModalOpen(item);
  };
  const [isSocialModalVisible, setIsSocialModalVisible] = useState(false);
  const openSocialModal = () => {
    setIsSocialModalVisible(true);
  };
  const [isModalOpenLihatSemuaKomentar, setIsModalOpenLihatSemuaKomentar] = useState(false);
  const showKomentar = (item: boolean) => {
    setIsModalOpenLihatSemuaKomentar(item);
  };
  const [newLikeComment, setNewLikeComment] = useState(1);
  const [updateComment, setUpdateComment] = useState<any>([]);
  const now = dayjs();
  const encrypt = process.env.NEXT_PUBLIC_SECRET_KEY + dtLogin?.phone_number + '2024' + now;
  const cryptoData = CryptoJS.HmacSHA256(encrypt, encrypt).toString(CryptoJS.enc.Hex);
  const [isLike, setIsLike] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [modalBookmarked, setModalBookmarked] = useState(false);
  const [modalUnBookmarked, setModalUnBookmarked] = useState(false);
  const [totalLike, setTotalLike] = useState('');
  const [totalComment, setTotalComment] = useState('');
  const [newArtikels, setNewArtikels] = useState(1);
  const subCategorySlug = props.artikel.url;
  useAsync(async () => {
    try {
      const userUid = decryptDLoginBE(cookie.load('d_login'));
      const newArtikel = `${g.API_ARTICLE_SLUG}/articles/detail/${subCategorySlug}?user_uid=${userUid.uid}`;
      const optArtikel = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${dtLogin.token}`
        }
      };
      const artikelFeedback = await fetch(newArtikel, optArtikel);
      const dataNewArtikel = await artikelFeedback.json();
      dataNewArtikel.status = artikelFeedback.status;
      if (dataNewArtikel.status === 200) {
        setIsLike(dataNewArtikel.data.record.is_like);
        setIsBookmarked(dataNewArtikel.data.record.is_bookmarked);
        setTotalLike(dataNewArtikel.data.record.total_like);
        setTotalComment(dataNewArtikel.data.record.total_comment);
      }
    } catch (error) {}
  }, [newArtikels, dtLogin]);
  useAsync(async () => {
    try {
      const userUid = decryptDLoginBE(cookie.load('d_login'));
      const filters = `order=desc&orderby=created_at&user_uid=${userUid.uid}`;
      const newComment = `${g.API_ARTICLE_SLUG}/articles/${artikelUid}/comments?${filters}`;
      const optArtikel = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${dtLogin.token}`
        }
      };
      const commentFeedback = await fetch(newComment, optArtikel);
      const dataNewComment = await commentFeedback.json();
      dataNewComment.status = commentFeedback.status;
      if (dataNewComment.status === 200) {
        setUpdateComment(dataNewComment);
      } else {
        // setUpdateComment(props.dataComments);
      }
    } catch (error) {
      // setUpdateComment(props.dataComments);
    }
  }, [newLikeComment, newArtikels, dtLogin]);
  const likeArtikel = async () => {
    try {
      const response = await fetch(`${g.API_PWD}/article-like/${artikelUid}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${dtLogin.token}`
        }
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const result = await response.json();
      if (result.meta.code === 204000) {
        setNewArtikels(newArtikels + 1);
        messageC(`${result.data.record.status === true ? 'Mama berhasil like artikel ini! Yuk, lanjut baca yang lainnya~' : 'Mama batal suka artikelnya. Cek artikel seru lainnya yuk Ma!'}`);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'page_article_like',
          uid: dtLogin.uid,
          email: dtLogin.email,
          name: dtLogin.name,
          uidArtikel: artikelUid
        });
      } else {
        messageC('Gagal Like Artikel ma');
      }
    } catch (error) {
      messageC('Gagal like Artikel ma');
    }
  };
  const saveArtikel = async () => {
    const isiBookmark = isBookmarked === false ? true : isBookmarked === true ? false : false;
    try {
      const response = await fetch(`${g.API_PWD}/article-history/${artikelUid}/${dtLogin.uid}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${dtLogin.token}`,
          'X-api-platform': cryptoData
        },
        body: JSON.stringify({
          bookmarked: isiBookmark,
          read: true
        })
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const result = await response.json();
      if (result.meta.code === 204000) {
        setNewArtikels(newArtikels + 1);
        setModalBookmarked(result.data.record.bookmarked);
        setModalUnBookmarked(false);
      }
    } catch (error) {
      messageC('Gagal Save Artikel');
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setModalBookmarked(false);
    setModalUnBookmarked(false);
    setIsModalOpenLihatSemuaKomentar(false);
  };
  const [isHeart, setIsHeart] = useState('');
  const [isBookmarks, setIsBoookmarks] = useState('');
  useEffect(() => {
    const hearts = props.artikel.is_like === false && isLike === true ? 'heartColor' : props.artikel.is_like === true && isLike === false ? 'heart' : props.artikel.is_like === true && isLike === true ? 'heartColor' : 'heart';
    setIsHeart(hearts);
    const bookmarks = isBookmarked === true ? 'bookmarkColor' : isBookmarked === false ? 'bookmark' : 'bookmark';
    setIsBoookmarks(bookmarks);
  }, [isLike, totalLike, isBookmarked]);
  const OS = isAndroid ? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID' : isWindows ? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID' : isMacOs ? 'https://apps.apple.com/id/app/hallobumil/id1507726157' : isIOS ? 'https://apps.apple.com/id/app/hallobumil/id1507726157' : 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID';
  return <div className={classes['page-body-wrap']}>
			<div className="container">
				<div className={classes.headContact}>
					<Row>
						<Col md={24} sm={24} xs={24} lg={17} xl={17}>
							<div style={{
              overflowX: 'hidden',
              wordBreak: 'break-word',
              width: '100%'
            }}>
								<ArticleDetail {...props.artikel} />
								<ArticleDownloadBanner />
							</div>
						</Col>
						<Col md={0} sm={0} xs={0} lg={7} xl={7} style={{
            textAlign: 'right'
          }}>
							<Image src={props?.artikel?.type === 'pre-pregnancy' ? '/images/artikel/pre-pregnancy-banner.webp' : props?.artikel?.type === 'pregnancy' ? '/images/artikel/pregnancy-banner.webp' : '/images/artikel/post-pregnancy-banner.webp'}
            // src={props?.artikel?.type === 'pre-pregnancy' ? '/images/artikel/pre-pregnancy-banner.webp' : props?.artikel?.type === 'pregnancy' ? '/images/artikel/pregnancy-banner-demo.jpg' : '/images/artikel/post-pregnancy-banner.webp'}
            preview={false} loading='lazy' width={300} height={600} onClick={() => window.open(OS)}
            // style={{ marginTop: '40px', marginBottom: '20px' }}
            />
							<div style={{
              marginLeft: '25px'
            }}>
								<GeneralArticleContainer {...props} />
							</div>
						</Col>
					</Row>
					<Row>
						<Col md={24} sm={24} xs={24} lg={17} xl={17}>
							<Row style={{
              paddingTop: '50px',
              paddingBottom: '20px'
            }}>
								<Col md={16} xs={0}>
									<Row>
										<Col className="d-flex align-items-center" style={{
                    marginRight: '15px'
                  }}>
											{dtLogin?.uid ? <IconCustom iconName={isBookmarks} onClick={() => {
                      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                      isBookmarked === true ? setModalUnBookmarked(true) : saveArtikel();
                    }} id="detail-artikel-bookmark" /> : <IconCustom iconName="bookmark" onClick={() => showModal(true)} id="detail-artikel-bookmark" />}
										</Col>
										<Col className="d-flex align-items-center" style={{
                    marginRight: '15px'
                  }}>
											{dtLogin?.uid ? <IconCustom iconName={isHeart} onClick={() => likeArtikel()} id="detail-artikel-like" /> : <IconCustom iconName="heart" onClick={() => showModal(true)} id="detail-artikel-like" />}
											<Typography className="fs-12 fs-md-14 ml-2" style={{
                      color: '#9ca3aa',
                      marginTop: '3px'
                    }} onClick={() => showModal(true)}>
												{dtLogin?.uid ? totalLike : props.artikel.total_like}
											</Typography>
										</Col>
										<Col className="d-flex align-dataArticles-center">
											{dtLogin?.uid ? <IconCustom iconName="comment" onClick={() => {
                      setIsModalOpenLihatSemuaKomentar(true);
                    }} id="detail-artikel-comments" /> : <IconCustom iconName="comment" onClick={() => {
                      showModal(true);
                    }} id="detail-artikel-comments" />}
											<Typography className="fs-12 fs-md-14 ml-2" style={{
                      color: '#9ca3aa',
                      marginTop: '3px'
                    }} onClick={() => showModal(true)}>
												{dtLogin?.uid ? totalComment : props.artikel.total_comment}
											</Typography>
										</Col>
									</Row>
								</Col>
								<Col md={8} xs={0}>
									<Space className={classes.icons} size="middle">
										<Paragraph>
											<Typography className={classes.sosmed}>Bagikan</Typography>
										</Paragraph>
										{sosmed.social_media?.map((item: any) => {
                    return item.name !== 'copylink' ? <Fragment key={item.name}>
													<a href={item.deeplink} rel="nofollow noreferrer" id={'detail-artikel-' + item.name} target="_blank">
														{item.icon && <Image key={item.name} className={classes['socmed-icon']} width={!xl && lg ? 28 : xs ? 16 : 32} height={!xl && lg ? 28 : xs ? 16 : 32} src={item.icon} alt={item.name} preview={false} style={{
                          cursor: 'pointer'
                        }} />}
													</a>
												</Fragment> : <Fragment key={item.name}>
													<div onClick={copyLink} id="detail-artikel-CopyLink">
														{item.icon && <Image key={item.name} className={classes['socmed-icon']} width={!xl && lg ? 28 : xs ? 16 : 32} height={!xl && lg ? 28 : xs ? 16 : 32} src={item.icon} alt={item.name} preview={false} style={{
                          cursor: 'pointer'
                        }} />}
													</div>
												</Fragment>;
                  })}
									</Space>
								</Col>
							</Row>
						</Col>
					</Row>
					<Row>
						<Col md={24} sm={24} xs={24} lg={17} xl={17}>
							{dtLogin?.uid && props.dataComments.length === 0 && updateComment?.data?.records?.length === 0 ? <div className={classes.btnFooter}>
									<div>
										<Image src="/images/artikel/loveHb.png" preview={false}
                // style={{ marginTop: '40px', marginBottom: '20px' }}
                width={120} height={120} />
										<Typography className={classes.paragraphKomen}>
											Belum ada komentar.
										</Typography>
										<Typography className={classes.paragraphKomen}>
											Tulis komentar Mama di kolom komentar !
										</Typography>
									</div>
									<br />
									<CommentComponentUserLogin dtLogin={dtLogin} artikelUid={artikelUid} cryptoData={cryptoData} messageC={messageC} newArtikels={newArtikels} setNewArtikels={setNewArtikels} />
								</div> : dtLogin?.uid && updateComment?.data?.records?.length > 0 ? <CommentComponentUserLogin dtLogin={dtLogin} artikelUid={artikelUid} cryptoData={cryptoData} messageC={messageC} newArtikels={newArtikels} setNewArtikels={setNewArtikels} /> : props.dataComments.length > 0 && !dtLogin?.uid ? <CommentComponentNonLogin setIsModalOpen={setIsModalOpen} /> : ''}
							{updateComment?.data?.records?.length > 0 ? updateComment?.data?.records?.slice(0, 5).map((item: any, index: any) => {
              return <CommentComponent key={index} item={item} artikelUid={artikelUid} dtLogin={dtLogin} xs={xs} newLikeComment={newLikeComment} setNewLikeComment={setNewLikeComment} showModal={showModal} messageC={messageC} />;
            }) : props.dataComments?.slice(0, 5).map((item: any, index: any) => {
              return <CommentComponent key={index} item={item} artikelUid={artikelUid} dtLogin={dtLogin} xs={xs} newLikeComment={newLikeComment} setNewLikeComment={setNewLikeComment} showModal={showModal} messageC={messageC} />;
            })}
							{updateComment?.data?.records?.length > 0 ? <div className={classes.btnFooter}>
										<Button className={classes.btn} onClick={() => showKomentar(true)} size="large">
											Lihat semua komentar
										</Button>
									</div> : props.dataComments.length === 0 && !dtLogin?.uid ? <div className={classes.btnFooter}>
											<div>
												<Image src="/images/artikel/loveHb.png" preview={false}
                // style={{ marginTop: '40px', marginBottom: '20px' }}
                width={120} height={120} />
												<Typography className={classes.paragraphKomen}>
													Belum ada komentar.
												</Typography>
												<Typography className={classes.paragraphKomen}>
													Login atau daftar dulu yuk ma biar bisa komen
												</Typography>
											</div>
											<br />
											<Button className={classes.btnRegisterLogin} href="/login" size="large" id="detail-artikel-daftar-login" type='primary'>
												Login/daftar yuk Ma
											</Button>
										</div> : dtLogin?.uid ? '' : <div className={classes.btnFooter}>
												<Button className={classes.btn} onClick={() => showKomentar(true)} size="large">
													Lihat semua komentar
												</Button>
											</div>}
						</Col>
					</Row>
					{xs ? <Row>
								<Col md={24} sm={24} xs={24} lg={24} xl={24}>
									<GeneralArticleContainer {...props} />
								</Col>
								{/* sticky menu mobile */}
								<Col md={0} sm={24} xs={24} lg={0} xl={0}>
									<Layout style={{
              display: 'flex',
              flexDirection: 'column'
            }}>
										<Footer style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                height: '62px',
                lineHeight: '10px',
                backgroundColor: '#ffffff',
                boxShadow: '0 -4px 12px rgba(48, 48, 48, 0.24)',
                borderTopLeftRadius: '16px',
                borderTopRightRadius: '16px',
                color: 'white',
                textAlign: 'center',
                zIndex: 1000
              }}>
											<Row>
												<Col span={6}>
													{dtLogin?.uid ? <IconCustom iconName={isBookmarks} onClick={() => {
                      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                      isBookmarked === true ? setModalUnBookmarked(true) : saveArtikel();
                    }} id="detail-artikel-bookmark" /> : <IconCustom iconName="bookmark" onClick={() => showModal(true)} id="detail-artikel-bookmark" />}
												</Col>
												<Col span={6}>
													<div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '3px',
                      marginLeft: '10px'
                    }}>
														{dtLogin?.uid ? <IconCustom iconName={isHeart} onClick={() => likeArtikel()} id="detail-artikel-like" /> : <IconCustom iconName="heart" onClick={() => showModal(true)} id="detail-artikel-like" />}
														<Typography className="fs-16 ml-1" style={{
                        color: '#9ca3aa'
                      }} onClick={() => showModal(true)}>
															{dtLogin?.uid ? totalLike : props.artikel.total_like}
														</Typography>
													</div>
												</Col>
												<Col span={6} style={{
                    textAlign: 'center'
                  }}>
													<div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '3px',
                      marginLeft: '15px'
                    }}>
														{dtLogin?.uid ? <IconCustom iconName="comment" onClick={() => {
                        setIsModalOpenLihatSemuaKomentar(true);
                      }} id="detail-artikel-comments" /> : <IconCustom iconName="comment" onClick={() => {
                        showModal(true);
                      }} id="detail-artikel-comments" />}
														<Typography className="fs-16 ml-1" style={{
                        color: '#9ca3aa'
                      }} onClick={() => showModal(true)}>
															{dtLogin?.uid ? totalComment : props.artikel.total_comment}
														</Typography>
													</div>
												</Col>
												<Col span={6}>
													<IconCustom iconName="share" onClick={openSocialModal} id="detail-artikel-comments" />
													<SocialShareModal dataShareButton={props.artikel.socialMedia || []} visibleModal={isSocialModalVisible} setVisibleModal={setIsSocialModalVisible} data={props.artikel} />
												</Col>
											</Row>
										</Footer>
									</Layout>
								</Col>
							</Row> : ''}
					<Modal open={isModalOpen} footer={null} closable={false} className={classes.bgModalL} width={1000}>
						<div style={{
            backgroundColor: 'transparent',
            paddingTop: '106px'
          }}>
							<div style={{
              backgroundColor: 'transparent',
              float: 'right'
            }}>
								<Button style={{
                border: 'none',
                backgroundColor: 'transparent'
              }} onClick={() => handleCancel()}>
									<CloseCircleOutlined style={{
                  color: 'grey'
                }} />
								</Button>
							</div>
							<div style={{
              backgroundColor: 'transparent',
              float: 'left',
              marginTop: lg ? '120px' : '86px'
            }}>
								<Typography className={classes.title}>Login Dulu yuk, Ma!</Typography>
								<Typography className={classes.paragraph}>
									Mama jadi lebih gampang like, comment dan simpan artikelnya di Hallobumil
								</Typography>
								<div className={classes.store}>
									<Button className={classes.btnlogin} onClick={() => router.push('/login')} size="large" id="masuk-sekarang">
										Masuk Sekarang
									</Button>
								</div>
							</div>
						</div>
					</Modal>
					{/* ========================= Modal Bookmarked ============================= */}
					<Modal open={modalBookmarked} footer={null} closable={false} className={classes.bgModal} width={1000}>
						<div style={{
            backgroundColor: 'transparent',
            marginTop: lg ? '106px' : '64px'
          }}>
							<div style={{
              backgroundColor: 'transparent',
              float: 'right'
            }}>
								<Button style={{
                border: 'none',
                backgroundColor: 'transparent'
              }} onClick={() => handleCancel()}>
									<CloseCircleOutlined style={{
                  color: 'grey'
                }} />
								</Button>
							</div>
							<div style={{
              backgroundColor: 'transparent',
              float: 'left',
              marginTop: lg ? '120px' : '86px'
            }}>
								<Typography className={classes.title}>Download Hallobumil Dulu yuk, Ma!</Typography>
								<Typography className={classes.paragraph}>
									Artikel ini berhasil disimpan. Mama bisa baca artikel
								</Typography>
								<Typography className={classes.paragraph}>
									yang disimpan lewat aplikasi Hallobumil ya.
								</Typography>
								<div className={classes.store}>
									<Button className={classes.btnlogin} onClick={() => window.open(OS)} size="large" id="download-sekarang">
										Download Sekarang
									</Button>
								</div>
							</div>
						</div>
					</Modal>
					{/* ========================= Modal Un-Bookmarked ============================= */}
					<Modal open={modalUnBookmarked} footer={null} closable={true} onCancel={handleCancel} className={classes.bgModalUnBookmarked} width={400}>
						<div style={{
            textAlign: 'center'
          }}>
							<Image src="/icons/unbookmarked.svg" preview={false} style={{
              marginTop: '40px',
              marginBottom: '20px'
            }} />
							<Typography className={classes.titleModal}> Yakin Ma Ga Disimpan lagi?</Typography>
							<Typography className={classes.pModal}>Semoga Mama bisa nemuin</Typography>
							<Typography className={classes.pModal}>yang serupa dengan topik ini!</Typography>
							<div>
								<ButtonBorderKomunitas style={{
                backgroundColor: '#F48A8A',
                color: 'white',
                cursor: 'pointer',
                width: '90%',
                marginTop: '10px',
                marginBottom: '10px'
              }} text={'Kembali'} onClick={handleCancel} />
							</div>
							<div>
								<ButtonBorder style={{
                cursor: 'pointer',
                width: '90%',
                marginBottom: '30px'
              }} text={'Ya, Saya Yakin'} onClick={() => saveArtikel()} />
							</div>
						</div>
					</Modal>
					{/* ===================================== Modal Lihat Semua Komentar ==================== */}
					<Modal open={isModalOpenLihatSemuaKomentar} footer={null} closable={false} className={classes.bgModal} width={1000}>
						<div style={{
            backgroundColor: 'transparent',
            marginTop: xs ? '76px' : '106px'
          }}>
							<div style={{
              backgroundColor: 'transparent',
              float: 'right'
            }}>
								<Button style={{
                border: 'none',
                backgroundColor: 'transparent'
              }} onClick={() => handleCancel()}>
									<CloseCircleOutlined style={{
                  color: 'grey'
                }} />
								</Button>
							</div>
							<div style={{
              backgroundColor: 'transparent',
              float: 'left',
              marginTop: lg ? '120px' : '60px'
            }}>
								<Typography className={classes.title}>Download Hallobumil Dulu yuk, Ma!</Typography>
								{dtLogin?.uid?.length > 0 ? <div>
										<Typography className={classes.paragraph}>
											Mama bisa lihat semua komentar dan simpan artikel ini lewat aplikasi
										</Typography>
										<Typography className={classes.paragraph}>Hallobumil ya ma.</Typography>
									</div> : <div>
										<Typography className={classes.paragraph}>
											Mama bisa like, comment dan simpan artikel ini lewat aplikasi Hallobumil
										</Typography>
										<Typography className={classes.paragraph}>
											yang disimpan lewat aplikasi Hallobumil ya.
										</Typography>
									</div>}
								<div className={classes.store}>
									<Button className={classes.btnlogin} onClick={() => window.open(OS)} size="large" id="download-sekarang">
										Download Sekarang
									</Button>
								</div>
							</div>
						</div>
					</Modal>
				</div>
			</div>
		</div>;
};
export default ArticleDetailContainer;